import { render, staticRenderFns } from "./ChargesDetail.vue?vue&type=template&id=174e4b39"
import script from "./ChargesDetail.vue?vue&type=script&lang=js"
export * from "./ChargesDetail.vue?vue&type=script&lang=js"
import style0 from "./ChargesDetail.vue?vue&type=style&index=0&id=174e4b39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports